import { FC } from 'react';
import styled from 'styled-components';

import { RoleRadioBlockProps } from './RoleRadioBlock';

const Wrapper = styled.div`
  line-height: 20px;
`;
const Label = styled.div`
  font-weight: 700;
  font-size: 14px;
`;
const List = styled.div`
  margin-top: 7px;
`;
const Item = styled.div`
  font-weight: 400;
  font-size: 11px;

  &::before {
    content: '•';
    color: #30aef2;
    margin-left: 5px;
  }
`;

const RadioLabel: FC<Pick<RoleRadioBlockProps, 'features' | 'label'>> = ({ label, features }) => (
  <Wrapper>
    <Label>{label}</Label>
    <List>
      {features.map(name => (
        <Item>{name}</Item>
      ))}
    </List>
  </Wrapper>
);

export default RadioLabel;
